// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-header-label-creator[data-v-656d139e]{display:flex;flex-direction:column;justify-content:center;align-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
